<aside [class.w-20]="layoutService.isSidebarCollapsed()" [class.w-64]="!layoutService.isSidebarCollapsed()" class="bg-brand-sidebar border-r border-brand-border flex flex-col justify-between h-full z-20 shrink-0 transition-all duration-300">
  <div data-purpose="sidebar-top">
    <div class="p-6 flex items-center space-x-2">
      <div class="bg-brand-primary w-8 h-8 rounded-lg flex items-center justify-center text-white font-bold text-xl shadow-sm">S</div>
      @if (!layoutService.isSidebarCollapsed()) {
        <span class="text-xl font-bold tracking-tight dark:text-slate-100">SIG</span>
        <span class="text-[9px] font-semibold uppercase tracking-widest text-gray-400 dark:text-slate-500 mt-2 select-none">beta</span>
      }
    </div>
    <nav class="mt-4 px-3 space-y-1">
      @if (canSeeMainApp()) {
        <a [routerLink]="AppRoutes.Dashboard.Root" routerLinkActive="sidebar-item-active" class="flex items-center px-3 py-2 text-sm font-medium rounded-md text-brand-muted hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors">
          <span class="material-symbols-outlined mr-3 text-[20px]">dashboard</span>
          @if (!layoutService.isSidebarCollapsed()) { Dashboard }
        </a>
        <a [routerLink]="AppRoutes.Clientes" routerLinkActive="sidebar-item-active" class="flex items-center px-3 py-2 text-sm font-medium rounded-md text-brand-muted hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors">
          <span class="material-symbols-outlined mr-3 text-[20px]">business</span>
          @if (!layoutService.isSidebarCollapsed()) { Clientes }
        </a>
        <a [routerLink]="AppRoutes.Cronograma" routerLinkActive="sidebar-item-active" class="flex items-center px-3 py-2 text-sm font-medium rounded-md text-brand-muted hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors">
          <span class="material-symbols-outlined mr-3 text-[20px]">calendar_month</span>
          @if (!layoutService.isSidebarCollapsed()) { Cronograma }
        </a>
        <a [routerLink]="AppRoutes.Equipe" routerLinkActive="sidebar-item-active" class="flex items-center px-3 py-2 text-sm font-medium rounded-md text-brand-muted hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors">
          <span class="material-symbols-outlined mr-3 text-[20px]">groups</span>
          @if (!layoutService.isSidebarCollapsed()) { Equipe }
        </a>
      }
      @if (canSeeOneOnOne()) {
        <a [routerLink]="AppRoutes.OneOnOne" routerLinkActive="sidebar-item-active" class="flex items-center px-3 py-2 text-sm font-medium rounded-md text-brand-muted hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors">
          <span class="material-symbols-outlined mr-3 text-[20px]">diversity_3</span>
          @if (!layoutService.isSidebarCollapsed()) { 1:1 }
        </a>
      }
      @if (canSeeOmbudsman()) {
        <a [routerLink]="AppRoutes.Ouvidoria.Root" routerLinkActive="sidebar-item-active" class="flex items-center px-3 py-2 text-sm font-medium rounded-md text-brand-muted hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors">
          <span class="material-symbols-outlined mr-3 text-[20px]">support_agent</span>
          @if (!layoutService.isSidebarCollapsed()) { Ouvidoria }
        </a>
      }
      @if (canSeeMainApp()) {
        <a [routerLink]="AppRoutes.Projetos" routerLinkActive="sidebar-item-active" class="flex items-center px-3 py-2 text-sm font-medium rounded-md text-brand-muted hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors">
          <span class="material-symbols-outlined mr-3 text-[20px]">account_tree</span>
          @if (!layoutService.isSidebarCollapsed()) { Projetos }
        </a>
        @if (canSeeRecruitment()) {
          <a [routerLink]="AppRoutes.Recrutamento.Root" routerLinkActive="sidebar-item-active" class="flex items-center px-3 py-2 text-sm font-medium rounded-md text-brand-muted hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors">
            <span class="material-symbols-outlined mr-3 text-[20px]">person_search</span>
            @if (!layoutService.isSidebarCollapsed()) { Recrutamento }
          </a>
        }
      }
      @if (canSeeTimeTracking()) {
        <div class="pt-4">
          <button (click)="isHoursOpen.set(!isHoursOpen())" class="w-full flex items-center justify-between px-3 py-2 text-sm font-medium text-brand-muted hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors rounded-md">
            <div class="flex items-center">
              <span class="material-symbols-outlined mr-3 text-[20px]">schedule</span>
              @if (!layoutService.isSidebarCollapsed()) { Controle de Horas }
            </div>
            @if (!layoutService.isSidebarCollapsed()) {
              <span class="material-symbols-outlined text-[16px] transition-transform" [class.rotate-180]="isHoursOpen()">expand_more</span>
            }
          </button>
          @if (isHoursOpen() && !layoutService.isSidebarCollapsed()) {
            <div class="mt-1 space-y-1 pl-10 pr-3">
              <a [routerLink]="AppRoutes.ControleDeHoras.MeuMes" routerLinkActive="text-brand-primary font-bold bg-brand-primary/5" class="block px-3 py-2 text-sm font-medium text-brand-muted hover:bg-gray-50 dark:hover:bg-slate-700 rounded-md transition-colors">
                Meu mês
              </a>
              <a [routerLink]="AppRoutes.ControleDeHoras.MeuBanco" routerLinkActive="text-brand-primary font-bold bg-brand-primary/5" class="block px-3 py-2 text-sm font-medium text-brand-muted hover:bg-gray-50 dark:hover:bg-slate-700 rounded-md transition-colors">
                Meu banco
              </a>
              <a [routerLink]="AppRoutes.ControleDeHoras.MeuRecesso" routerLinkActive="text-brand-primary font-bold bg-brand-primary/5" class="block px-3 py-2 text-sm font-medium text-brand-muted hover:bg-gray-50 dark:hover:bg-slate-700 rounded-md transition-colors">
                Meu recesso
              </a>
              @if (canReviewHours()) {
                <a [routerLink]="AppRoutes.ControleDeHoras.Conferencia" routerLinkActive="text-brand-primary font-bold bg-brand-primary/5" class="block px-3 py-2 text-sm font-medium text-brand-muted hover:bg-gray-50 dark:hover:bg-slate-700 rounded-md transition-colors">
                  Conferência
                </a>
              }
              @if (canManageHours()) {
                <a [routerLink]="AppRoutes.ControleDeHoras.Banco" routerLinkActive="text-brand-primary font-bold bg-brand-primary/5" class="block px-3 py-2 text-sm font-medium text-brand-muted hover:bg-gray-50 dark:hover:bg-slate-700 rounded-md transition-colors">
                  Banco
                </a>
                <a [routerLink]="AppRoutes.ControleDeHoras.Recessos" routerLinkActive="text-brand-primary font-bold bg-brand-primary/5" class="block px-3 py-2 text-sm font-medium text-brand-muted hover:bg-gray-50 dark:hover:bg-slate-700 rounded-md transition-colors">
                  Recessos
                </a>
                <a [routerLink]="AppRoutes.ControleDeHoras.Configuracoes" routerLinkActive="text-brand-primary font-bold bg-brand-primary/5" class="block px-3 py-2 text-sm font-medium text-brand-muted hover:bg-gray-50 dark:hover:bg-slate-700 rounded-md transition-colors">
                  Configurações
                </a>
              }
            </div>
          }
        </div>
      }
      @if (canSeeSettings()) {
        <div class="pt-4">
          <button (click)="isSettingsOpen.set(!isSettingsOpen())" class="w-full flex items-center justify-between px-3 py-2 text-sm font-medium text-brand-muted hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors rounded-md">
            <div class="flex items-center">
              <span class="material-symbols-outlined mr-3 text-[20px]">settings</span>
              @if (!layoutService.isSidebarCollapsed()) { Configurações }
            </div>
            @if (!layoutService.isSidebarCollapsed()) {
              <span class="material-symbols-outlined text-[16px] transition-transform" [class.rotate-180]="isSettingsOpen()">expand_more</span>
            }
          </button>
          @if (isSettingsOpen() && !layoutService.isSidebarCollapsed()) {
            <div class="mt-1 space-y-1 pl-10 pr-3">
              @if (canSeeRoles()) {
                <a [routerLink]="AppRoutes.Configuracoes.Cargos" routerLinkActive="text-brand-primary font-bold bg-brand-primary/5" class="block px-3 py-2 text-sm font-medium text-brand-muted hover:bg-gray-50 dark:hover:bg-slate-700 rounded-md transition-colors">
                  Cargos
                </a>
              }
              @if (isAdmin()) {
                <a [routerLink]="AppRoutes.Configuracoes.Produtos" routerLinkActive="text-brand-primary font-bold bg-brand-primary/5" class="block px-3 py-2 text-sm font-medium text-brand-muted hover:bg-gray-50 dark:hover:bg-slate-700 rounded-md transition-colors">
                  Produtos
                </a>
              }
              @if (canManageEmailTemplates()) {
                <a [routerLink]="AppRoutes.Configuracoes.TemplatesEmail" routerLinkActive="text-brand-primary font-bold bg-brand-primary/5" class="block px-3 py-2 text-sm font-medium text-brand-muted hover:bg-gray-50 dark:hover:bg-slate-700 rounded-md transition-colors">
                  Templates de email
                </a>
              }
              <a [routerLink]="AppRoutes.Configuracoes.Usuarios" routerLinkActive="text-brand-primary font-bold bg-brand-primary/5" class="block px-3 py-2 text-sm font-medium text-brand-muted hover:bg-gray-50 dark:hover:bg-slate-700 rounded-md transition-colors">
                Usuários
              </a>
            </div>
          }
        </div>
      }
    </nav>
  </div>
  <div class="p-4 border-t border-brand-border" data-purpose="sidebar-bottom">
    <div class="flex items-center justify-between">
      <div class="flex items-center">
        <app-user-avatar
          [name]="authService.userProfile()?.name || 'Usuário'"
          [avatar]="authService.userProfile()?.avatar"
          size="sm">
        </app-user-avatar>
        @if (!layoutService.isSidebarCollapsed()) {
          <div class="ml-3 overflow-hidden">
            <p class="text-xs font-bold text-gray-900 dark:text-slate-100 truncate">{{ authService.userProfile()?.name || 'Usuário' }}</p>
            <p class="text-[10px] text-gray-500 dark:text-slate-400 truncate uppercase tracking-tighter">{{ authService.userProfile()?.accessProfile || '' }}</p>
          </div>
        }
      </div>
      @if (!layoutService.isSidebarCollapsed()) {
        <button (click)="authService.logout()" class="text-gray-400 dark:text-slate-500 hover:text-gray-600 dark:hover:text-slate-300">
          <span class="material-symbols-outlined text-[20px]">logout</span>
        </button>
      }
    </div>
  </div>
</aside>
